import { render } from "./StreamSidebarSource.vue?vue&type=template&id=343a3a8e"
import script from "./StreamSidebarSource.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamSidebarSource.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/StreamSidebarSource.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "343a3a8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('343a3a8e', __exports__)) {
    api.reload('343a3a8e', __exports__)
  }
  
  module.hot.accept("./StreamSidebarSource.vue?vue&type=template&id=343a3a8e", () => {
    api.rerender('343a3a8e', render)
  })

}


export default __exports__